<div class="grid" *ngIf="carInformacionInicial">
  <div class="col-12 md:col-12 lg:col-12 text-center">
    <i class="fa fa-refresh fa-spin fa-3x fa-fw"></i><br />
    <span>{{ "LBL_CONSULTANDO" | translate }}</span>
  </div>
</div>
<div *ngIf="!carInformacionInicial">
  <div class="grid">
    <div class="col-12">
      <p-accordion id="accordion" [multiple]="false" (onOpen)="abrirAcordeon($event)">
        <p-accordionTab header="{{ 'TASASVARIABLES.LBL_DATOSGENERALES' | translate }}"
                        [selected]="tabSeleccionado === 'DATOSGEN'">
          <form [formGroup]="formulario" (ngSubmit)="onSubmit()" novalidate id="formulario" name="formulario">
            <div class="grid form-group">
              <div class="col-12 md:col-4 lg:col-4">
                <div class="div-form">
                  <label>* {{ "TASASVARIABLES.LBL_CODIGO" | translate }}</label>
                  <input autocomplete="false" formControlName="codigo" name="codigo" [disabled]="registro" [upper]="true"
                         id="codigo" [maxlength]="10" appTexto [sinCaracteres]="true" [sinComa]="true" [sinEspacio]="true" [sinPunto]="true"
                         pInputText (blur)="validarCodigo()"/>
                  <div class="p-message p-messages-error p-corner-all"
                       *ngIf="submitted && f.codigo.invalid">
                    {{ "TASASVARIABLES.LBL_CODIGO" | translate }}
                    {{ "LBL_REQUERIDO" | translate }}
                  </div>
                  <div class="p-message p-messages-error p-corner-all" *ngIf="codExiste">
                    {{ 'MSG_CODIGOEXISTE' | translate}}
                  </div>
                </div>
              </div>
              <div class="col-12 md:col-4 lg:col-4">
                <div class="div-form">
                  <label>* {{ "TASASVARIABLES.LBL_NOMBREDETASA" | translate }}</label>
                  <input autocomplete="false" formControlName="tasaVariable" name="tasaVariable"
                         id="tasaVariable" [maxlength]="100" pInputText/>
                  <div class="p-message p-messages-error p-corner-all"
                       *ngIf="submitted && f.tasaVariable.invalid">
                    {{ "TASASVARIABLES.LBL_NOMBREDETASA" | translate }}
                    {{ "LBL_REQUERIDO" | translate }}
                  </div>
                </div>
              </div>
              <div class="col-12 md:col-4 lg:col-4">
                <div class="div-form">
                  <label>* {{ "TASASVARIABLES.LBL_CODIGOSHIVAM" | translate }}</label>
                  <input autocomplete="false" formControlName="codigoShivam" name="codigoShivam"
                         id="codigoShivam" [maxlength]="10" appTexto [sinEspacio]="true" pInputText/>
                  <div class="p-message p-messages-error p-corner-all"
                       *ngIf="submitted && f.codigoShivam.invalid">
                    {{ "TASASVARIABLES.LBL_CODIGOSHIVAM" | translate }}
                    {{ "LBL_REQUERIDO" | translate }}
                  </div>
                </div>
              </div>

              <div class="col-12 md:col-12 lg:col-12">
                <div class="div-form">
                  <label>{{ "TASASVARIABLES.LBL_DESCRIPCION" | translate }}</label>
                  <input autocomplete="false" formControlName="descripcion" name="descripcion"
                         id="descripcion" [maxlength]="500" pInputText/>
                  <div class="p-message p-messages-error p-corner-all"
                       *ngIf="submitted && f.descripcion.invalid">
                    {{ "TASASVARIABLES.LBL_DESCRIPCION" | translate }}
                    {{ "LBL_REQUERIDO" | translate }}
                  </div>
                </div>
              </div>
            </div>

            <div class="grid form-group">
              <div class="col-12 md:col-4 lg:col-6">
                <p-checkbox label="{{ 'LBL_HABILITADO' | translate}}" binary="true"
                            id="indicadorHabilitado"
                            name="indicadorHabilitado"
                            formControlName="indicadorHabilitado"></p-checkbox>
              </div>
            </div>

            <div class="grid form-footer-buttons">
              <div class="form-group col-12">
                <div *ngIf="!guardando">
                  <a (click)="regresar(formulario.dirty)" class="cancelar">{{ (verDetalle ? "LBL_SALIR" : "BTN_CANCELAR") | translate }}</a>
                  <button icon="fa fa-floppy-o" label="{{ 'BTN_GUARDAR' | translate }}" type="submit" pButton *ngIf="!verDetalle"></button>
                </div>
                <div *ngIf="guardando">
                  <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i><br />
                  <span>{{ "LBL_GUARDANDO" | translate }}</span>
                </div>
              </div>
            </div>
          </form>
        </p-accordionTab>
        <p-accordionTab header="{{ 'TASASVARIABLES.LBL_TASAS' | translate }}" [disabled]="!registro"
                        [selected]="tabSeleccionado === 'TASAS'">
          <app-tasas-variables-editar-tasa [tasaVariable]="registro" [verDetalle]="verDetalle" *ngIf="registro"></app-tasas-variables-editar-tasa>
        </p-accordionTab>
      </p-accordion>
      <div class="grid form-footer-buttons">
        <div class="form-group col-12">
          <button icon="fa fa-arrow-left" label="{{ 'BTN_REGRESAR' | translate }}" type="button" pButton
                  (click)="regresar(false)"></button>
        </div>
      </div>
    </div>
  </div>
</div>

<p-confirmDialog #cd>
  <ng-template pTemplate="footer">
    <button type="button" pButton icon="fa fa-close" label="{{ 'LBL_NO' | translate }}" (click)="cd.reject()"></button>
    <button type="button" pButton icon="fa fa-check" label="{{ 'LBL_SI' | translate }}" (click)="cd.accept()"></button>
  </ng-template>
</p-confirmDialog>
